export default __webpack_public_path__ + "static/media/pencil-alt.bb651596.svg";